import React from 'react';
import { FileTextIcon, MessageSquareIcon, BookmarkIcon, DownloadIcon, SparklesIcon } from 'lucide-react';
interface AlgaCoffeeNotesWidgetProps {
  coffeeHost: string;
}
const AlgaCoffeeNotesWidget: React.FC<AlgaCoffeeNotesWidgetProps> = ({
  coffeeHost
}) => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-551">
      <div className="p-4 border-b border-gray-200 flex items-center" data-id="element-552">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-custom-green to-emerald-600 flex items-center justify-center mr-3 shadow-sm" data-id="element-553">
          <SparklesIcon size={16} className="text-white" data-id="element-554" />
        </div>
        <div data-id="element-555">
          <h2 className="text-base font-semibold text-gray-800" data-id="element-556">
            Appunti intelligenti
          </h2>
          <p className="text-xs text-gray-500" data-id="element-557">Powered by Greenback AI</p>
        </div>
      </div>
      <div className="p-4" data-id="element-558">
        <div className="space-y-4" data-id="element-559">
          <div className="flex items-center justify-between" data-id="element-560">
            <h4 className="text-sm font-medium text-gray-800" data-id="element-561">
              Appunti e note
            </h4>
            <div className="flex items-center space-x-2" data-id="element-562">
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-563">
                <BookmarkIcon size={16} className="text-gray-500" data-id="element-564" />
              </button>
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-565">
                <DownloadIcon size={16} className="text-gray-500" data-id="element-566" />
              </button>
            </div>
          </div>
          <div className="bg-custom-green/5 p-2 rounded-lg border border-custom-green/20 text-xs text-gray-600 flex items-center" data-id="element-567">
            <div className="w-5 h-5 rounded-full bg-custom-green/20 flex items-center justify-center mr-2 flex-shrink-0" data-id="element-568">
              <SparklesIcon size={10} className="text-custom-green" data-id="element-569" />
            </div>
            <span data-id="element-570">
              Ho analizzato autonomamente l'evento e preparato questi appunti
              per te
            </span>
          </div>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-571">
            <div className="flex items-start mb-2" data-id="element-572">
              <FileTextIcon size={16} className="text-custom-green mt-1 mr-2 flex-shrink-0" data-id="element-573" />
              <div data-id="element-574">
                <h5 className="text-sm font-medium text-gray-800" data-id="element-575">
                  Concetti chiave
                </h5>
                <ul className="list-disc pl-5 text-sm text-gray-600 mt-1 space-y-1" data-id="element-576">
                  <li data-id="element-577">Integrazione ESG nel core business</li>
                  <li data-id="element-578">Misurazione dell'impatto attraverso KPI specifici</li>
                  <li data-id="element-579">Coinvolgimento degli stakeholder</li>
                  <li data-id="element-580">Reporting trasparente e verificabile</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-581">
            <div className="flex items-start mb-2" data-id="element-582">
              <MessageSquareIcon size={16} className="text-custom-green mt-1 mr-2 flex-shrink-0" data-id="element-583" />
              <div data-id="element-584">
                <h5 className="text-sm font-medium text-gray-800" data-id="element-585">
                  Citazioni importanti
                </h5>
                <p className="text-sm text-gray-600 mt-1 italic" data-id="element-586">
                  "La sostenibilità non è più un'opzione, ma una necessità
                  strategica per rimanere competitivi nel mercato attuale."
                </p>
                <p className="text-sm text-gray-500 mt-1" data-id="element-587">- {coffeeHost}</p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-588">
            <div className="flex items-start mb-2" data-id="element-589">
              <FileTextIcon size={16} className="text-custom-green mt-1 mr-2 flex-shrink-0" data-id="element-590" />
              <div data-id="element-591">
                <h5 className="text-sm font-medium text-gray-800" data-id="element-592">
                  Risorse consigliate
                </h5>
                <ul className="list-disc pl-5 text-sm text-gray-600 mt-1 space-y-1" data-id="element-593">
                  <li data-id="element-594">
                    Report "ESG Integration in Business Strategy" (EIIS, 2023)
                  </li>
                  <li data-id="element-595">Framework GRI per il reporting di sostenibilità</li>
                  <li data-id="element-596">Casi studio di aziende leader nel settore</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="mt-3 flex justify-center" data-id="element-597">
            <button className="text-xs text-custom-green hover:text-custom-green/80 flex items-center" data-id="element-598">
              <FileTextIcon size={12} className="mr-1" data-id="element-599" />
              Richiedi appunti specifici
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default AlgaCoffeeNotesWidget;